import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * useRicercaPrestazioni — la ricerca a tendina del catalogo in agenda.
 *
 * Stava scritta due volte dentro Agenda.jsx, identica a parte da dove
 * arrivava l'id dell'agenda: una nella finestra di modifica, una in quella
 * di creazione. Due copie della stessa cosa vogliono dire che una delle due
 * prima o poi resta indietro - e' gia' successo con il ritardo di 300ms,
 * commentato in un blocco solo.
 *
 * Le due regole che valgono ovunque:
 *  - da tre lettere in su, altrimenti la prima lettera interrogherebbe il
 *    server su tutto il catalogo;
 *  - 300 ms di attesa, per non chiedere a ogni tasto.
 *
 * @param {object} opzioni
 *  - agendaId   l'agenda su cui filtrare le prestazioni
 *  - attiva     false mette in pausa la ricerca (finestra chiusa)
 * @returns { ricerca, setRicerca, risultati, tutte, setTutte, pulisci }
 */
export default function useRicercaPrestazioni({ agendaId, attiva = true } = {}) {
    const [ricerca, setRicerca] = useState('');
    const [risultati, setRisultati] = useState([]);
    // Le prestazioni non associate a nessun medico: fuori di norma
    const [tutte, setTutte] = useState(false);

    useEffect(() => {
        if (!attiva || ricerca.trim().length < 3) { setRisultati([]); return undefined; }
        let vivo = true;
        const t = setTimeout(async () => {
            try {
                const r = await api.get('/agenda/prestazioni', {
                    params: {
                        q: ricerca,
                        agenda_id: agendaId,
                        tutte: tutte ? 'true' : undefined,
                    },
                });
                if (vivo) setRisultati(r.data.data.prestazioni || []);
            } catch (e) { /* la tendina resta vuota: non c'e' niente da dire */ }
        }, 300);
        return () => { vivo = false; clearTimeout(t); };
    }, [ricerca, tutte, agendaId, attiva]);

    const pulisci = () => { setRicerca(''); setRisultati([]); };

    return { ricerca, setRicerca, risultati, tutte, setTutte, pulisci };
}
